module.exports = __webpack_public_path__ + "catalog/items/dining/round-dining-table-for-4/round-dining-table-for-4.svg";